import React from 'react'
import QuestionForm from './QuestionForm'
import { useSelector } from 'react-redux'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import { useParams } from 'react-router'
import { useFetchQuestionsQuery, useUpdateQuestionMutation } from '../../../../../store/apis/question.api'
import {
    fetchQuestionsSelectors,
    getQuestionById,
} from '../../../../../store/apis/utils/selectors/question.api.selectors'
import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import { useVersionId } from '../../../../../utils/parseURL.helper'

const EditQuestionForm = ({ form }) => {
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    const { token } = useParams()
    const versionId = useVersionId()
    const { data: questions } = useFetchQuestionsQuery({ token, versionId })
    const editingQuestion = getQuestionById(questions, editingQuestionId)

    const { data: earlierQuestions } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.earlierQuestions({ id: editingQuestionId }, result),
        },
    )

    const [updateQuestion, updateQuestionResult] = useUpdateQuestionMutation()

    const handleEditQuestion = async values => {
        const response = await updateQuestion({
            token,
            versionId,
            id: editingQuestionId,
            ...editingQuestion,
            ...values,
        })

        if ('data' in response) {
            openNotificationWithIcon('success', 'Question updated successfully')
            return true
        }
    }

    return (
        <QuestionForm
            form={form}
            onSubmit={handleEditQuestion}
            initialValues={editingQuestion}
            loading={updateQuestionResult?.isLoading}
            error={updateQuestionResult?.error}
            earlierQuestions={earlierQuestions}
            formResetTrigger={editingQuestionId}
            questions={questions}
            submitButtonText="Save"
        />
    )
}

export default EditQuestionForm
